//---------	Global imports
import React from 'react';

//---------	Styles
import './styles.sass';
import '../../css/partials/slider.sass';

//---------	Plugins
import { forEach, isNumber, isString } from 'lodash';
import Slider from 'react-slick';

//---------	Translations
import { T } from '../../../translations'



class ProductCustomizer extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    this.selectedVariants = props.selectedVariants;
    this.variants = props.variants;
    
    this.variantHeight = 0;
    this.activeVariantHeight = 0;
    
    this.state = {
      renderedVariants: [],
      activeVariantTab: '',
      sendToast: false,
      gallery: []
    };
    
    this.slick = {
      speed: 300,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false
    };
    
    this.renderVariants = this.renderVariants.bind(this);
    this.renderVariant = this.renderVariant.bind(this);
    this.toggleVariantsList = this.toggleVariantsList.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.zoom = this.zoom.bind(this);
    this.selectVariantFromGallery = this.selectVariantFromGallery.bind(this);
  }
  
  
  //---------	React functions
  componentDidMount() {
    this.renderVariants();
  }
  
  
  //---------	Custom functions
  renderVariants() {
    const renderedVariants = [];
    
    forEach(this.variants, (variantOptions, variantName) => {
      
      let activeVariant = variantName === this.state.activeVariantTab,
        styles = {
          height: activeVariant ? this.activeVariantHeight : 0
        },
        variantClass = activeVariant ? 'CalipsyProductCustomizer-variantsGroup state-active' : 'CalipsyProductCustomizer-variantsGroup';
      
      renderedVariants.push(
        <div key={variantName} className={variantClass}>
          <h5 onClick={() => this.toggleVariantsList(variantName)}>{variantName}</h5>
          <div style={styles}>
            {this.renderVariant(variantName, variantOptions)}
          </div>
        </div>
      );
    });
    
    this.setState({renderedVariants: renderedVariants});
  }
  
  renderVariant(variantCategory, variantOptions) {
    const renderedVariantOptions = [];
    
    let i = 0,
      id,className,button;
    forEach(variantOptions, (price, variant) => {
      id = variantCategory + '_' + variant.toLowerCase().replace(' ', '-').trim();
      className = `CalipsyProductCustomizer-variant ${variantCategory}`;
      
      button = variantCategory === 'color' || variantCategory === 'pattern' ? (
          <button data-index={i} data-variant={`${variantCategory}_${variant}`} onClick={(e) => this.zoom(id, e.currentTarget.getAttribute('data-index'))}>+</button>
        ) : null;
      
      renderedVariantOptions.push(
        <div key={variant} className={className}>
          <input type="radio" name={variantCategory} id={id}
                 checked={this.selectedVariants[variantCategory] === variant}
                 onChange={() => this.changeVariant(variantCategory, variant)}/>
          <label htmlFor={id}>
            <div className={id}>thumbnail</div>
            <span dangerouslySetInnerHTML={{__html: variantCategory === 'size' || variantCategory === 'material' ? T.customizer[variantCategory][variant] : variant}}></span>
            {button}
          </label>
        </div>
      );
      i++
    });
    
    return renderedVariantOptions;
  }
  
  setVariantHeight(variantName) {
    let items = document.getElementsByClassName(`CalipsyProductCustomizer-variant ${variantName}`);
    let computedStyles = window.getComputedStyle(items[0],null);
    let itemsPerRow = (ww) => {
      if(ww >= 992) {
        return 3
      } else if(ww >= 768) {
        return 2
      } else if(ww >= 460) {
        return 4
      }
      return 3
    };
    let rows = Math.ceil(items.length / itemsPerRow(window.innerWidth));
    
    return rows * parseInt(computedStyles.getPropertyValue('height')) + rows * parseInt(computedStyles.getPropertyValue('margin-bottom'));
  }
  
  toggleVariantsList(variantName, open) {
    
    
  
    if(this.state.activeVariantTab === variantName && !open){
      this.setState({activeVariantTab: ''}, this.renderVariants);
      return;
    }
  
    this.activeVariantHeight = this.setVariantHeight(variantName);
    this.setState({activeVariantTab: variantName}, this.renderVariants);
  }
  
  changeVariant(variantName, selectedVariant) {
  
    this.selectedVariants[variantName] = selectedVariant;
    
    this.props.changeVariant(this.selectedVariants);
    this.renderVariants();
    
    if (variantName === 'material') return;
    
    this.updateSnipcart(variantName, selectedVariant);
  }
  
  updateSnipcart(variantName, selectedVariant) {
    let nmb;
    
    switch (variantName) {
      case 'color':
        nmb = 2;
        break;
      case 'size':
        nmb = 3;
        break;
      case 'pattern':
        nmb = 4;
        break;
    }
    
    if (isNumber(nmb)) {
      $('#CalipsyProduct-classic').data(`item-custom${nmb}-value`, selectedVariant);
      $('#CalipsyProduct-deluxe').data(`item-custom${nmb}-value`, selectedVariant);
    }
  }
  
  toggleSidebar() {
    this.props.toggleSidebar('sendToast')
  }
  
  zoom(zoom, i) {
    if(!isString(zoom)) {
      this.setState({gallery: []});
      return
    }
  
    const galleryVariant = zoom.split('_')[0],
      galleryVariants = this.variants[galleryVariant];

    const gallery = [];
  
    let zoomClassName;
    forEach(galleryVariants, (price, name) => {
      zoomClassName = `${galleryVariant}_${name.replace(' ', '-').toLowerCase().trim()}`;
      gallery.push(
        <div key={name}>
          <div className={zoomClassName}></div>
        </div>
      );
    });
  
    this.setState({gallery: gallery}, () => {
      this.refs.slider.slickGoTo(i)
    });
  }
  
  selectVariantFromGallery() {
    this.changeVariant(this.state.activeVariantTab, Object.keys(this.variants[this.state.activeVariantTab])[this.refs.slider.innerSlider.state.currentSlide])
    this.zoom()
  }
  
  //---------	Render
  render() {
    
    let className = `CalipsyProductCustomizer ${this.props.productType}`

    return (
      <div className={className}>
        {this.state.renderedVariants}
        {
          this.state.gallery.length ? (
            <div className="CalipsyProductCustomizer-zoom">
              <div className="CalipsyProductCustomizer-zoomBackground" onClick={this.zoom}></div>
              
              <div className="CalipsyProductCustomizer-slider">
                <Slider ref='slider' {...this.slick} className={this.props.productType}>{this.state.gallery}</Slider>
                <button className="CalipsyProductCustomizer-selectVariant CalipsyButton" onClick={this.selectVariantFromGallery}>select</button>
              </div>
            </div>
            ) : null
        }
        <button className="CalipsyButton CalipsyButton-blue" onClick={() => this.props.toggleSidebar('sendToast')}>
          Update product
        </button>
      </div>
    );
  }
}

export default ProductCustomizer;


// WEBPACK FOOTER //
// ./src/components/ProductCustomizer/index.js